import React, { useState } from "react";
import popupsyle from "../../style/PopUp.module.css";
import editpopup from "../../style/Pages/EditPage.module.css";
import { TfiClose } from "react-icons/tfi";
import { useFetchSelectedLog } from "../../hooks/useLogs";
import CompanyView from "./CompanyView";
import PeopleView from "./PeopleView";
import viewLogStyle from "./../../style/Pages/ViewSelectedLg.module.css";
import PageLoader from "../../components/ui/Loader/PageLoader";
import FallbackAvatar from "../../components/ui/FallbackAvatar/FallbackAvatar";

const ViewSelectedLog = ({ id, onClose }) => {
  const { selectedLog, isLoading, error } = useFetchSelectedLog(id);
  const [viewCompany, setViewCompany] = useState(false);
  const [datas, setData] = useState([]);
  const [userDatas, setUserData] = useState([]);
  const [viewUser, setViewUser] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const getStatusText = (status) => {
    const isActive = status === "0";
    const statusText = isActive ? "Active" : "Deactive";
    const color = isActive ? "#059669" : "#dc2626";

    return <span style={{ color, fontWeight: "600" }}>{statusText}</span>;
  };

  const getAccessText = (access) => {
    return access === "all_people" ? "All People" : "Channel Managers";
  };

  const renderLogDetails = () => {
    if (!selectedLog) return null;

    const { action, category, editer_name, old_data, new_data } = selectedLog;

    return (
      <div className={viewLogStyle.card}>
        <div className={viewLogStyle.row}>
          <span className={viewLogStyle.label}>Action:</span>
          <span className={viewLogStyle.value}>{action}</span>
        </div>

        <div className={viewLogStyle.row}>
          <span className={viewLogStyle.label}>Category:</span>
          <span className={viewLogStyle.value}>{category}</span>
        </div>

        <div className={viewLogStyle.row}>
          <span className={viewLogStyle.label}>Performed By:</span>
          <span className={viewLogStyle.value}>{editer_name || "System"}</span>
        </div>

        {/* Action-specific details */}
        <div>
          <h4 className={viewLogStyle.detailsHeading}>Details:</h4>
          <div className={viewLogStyle.detailsContent}>
            {action === "Edit" &&
              renderUpdateDetails(category, old_data, new_data)}
            {action === "Add" && renderAddDetails(category, new_data)}
            {action === "Deactive" &&
              renderDeactivationDetails(category, old_data, new_data)}
          </div>
        </div>
      </div>
    );
  };

  // Update
  const renderUpdateDetails = (category, oldData, newData) => {
    if (category === "Group") {
      return renderUpdateGroup(oldData, newData);
    } else if (category === "Channel") {
      return renderUpdateChannel(oldData, newData);
    } else {
      return renderUpdateStaffRegisteration(oldData, newData);
    }
  };
  const handleViewCompany = (name, company_list) => {
    const data = {
      name: name,
      company_list: company_list,
    };
    setData(data);
    setViewCompany(true);
  };

  const handleViewUser = (name, userList) => {
    const data = {
      name: name,
      userList: userList,
    };
    setUserData(data);
    setViewUser(true);
  };

  const renderUpdateGroup = (oldData, newData) => {
    const oldDatas = Array.isArray(oldData) ? oldData[0] : oldData;
    const newDatas = Array.isArray(newData) ? newData[0] : newData;
    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Old Data</th>
              <th className={viewLogStyle.tableHeader}>Updated Data</th>{" "}
            </tr>
          </thead>
          <tbody>
            {/* {Object.entries(data).map(([key, value]) => ( */}
            <tr>
              <td className={viewLogStyle.tableCell}>Group Name</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.group_name}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.group_name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Group Icon</td>
              <td className={viewLogStyle.tableCell}>
                {oldDatas.group_icon !== null ? (
                  <img
                    alt="img"
                    className={viewLogStyle.images}
                    src={`${apiUrl}${oldDatas.group_icon}`}
                  />
                ) : (
                  <FallbackAvatar name={`${oldDatas.group_name} `} size={40} />
                )}
                {/* <img
                  alt="img"
                  className={viewLogStyle.images}
                  src={`${apiUrl}${oldDatas.group_icon}`}
                /> */}
              </td>
              <td className={viewLogStyle.tableCell}>
                {newDatas.group_icon !== null ? (
                  <img
                    alt="img"
                    className={viewLogStyle.images}
                    src={`${apiUrl}${newDatas.group_icon}`}
                  />
                ) : (
                  <FallbackAvatar name={`${newDatas.group_name} `} size={40} />
                )}
                {/* <img
                  alt="img"
                  className={viewLogStyle.images}
                  src={`${apiUrl}${newDatas.group_icon}`}
                /> */}
              </td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Admin</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(
                      oldDatas.group_name,
                      oldDatas.group_admin_details
                    )
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      newDatas.group_name,
                      newDatas.group_admin_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>User</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      oldDatas.group_name,
                      oldDatas.group_users_details
                    )
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      newDatas.group_name,
                      newDatas.group_users_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(oldDatas.group_status)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(newDatas.group_status)}
              </td>
            </tr>
            {/* <tr>
              <td></td>
              <td></td>
            </tr> */}
          </tbody>
        </table>
      </div>
    );
  };

  const renderUpdateChannel = (oldData, newData) => {
    // Handle array inputs by taking first element
    const oldObj = Array.isArray(oldData) ? oldData[0] : oldData;
    const newObj = Array.isArray(newData) ? newData[0] : newData;

    return (
      <div className={viewLogStyle.tableContainer}>
        {" "}
        {/* Changed to tableContainer */}
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Old Data</th>
              <th className={viewLogStyle.tableHeader}>Updated Data</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={viewLogStyle.tableCell}>Channel Name</td>
              <td className={viewLogStyle.tableCell}>{oldObj.channel_name}</td>
              <td className={viewLogStyle.tableCell}>{newObj.channel_name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Channel Topic</td>
              <td className={viewLogStyle.tableCell}>{oldObj.channel_topic}</td>
              <td className={viewLogStyle.tableCell}>{newObj.channel_topic}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Description</td>
              <td className={viewLogStyle.tableCell}>{oldObj.description}</td>
              <td className={viewLogStyle.tableCell}>{newObj.description}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Channel Managers</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      oldObj.channel_name,
                      oldObj.channel_manager_details // Fixed: use old data
                    )
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      newObj.channel_name,
                      newObj.channel_manager_details // Fixed: use new data
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>User</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      oldObj.channel_name,
                      oldObj.get_channel_people_details // Fixed: use old data
                    )
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      newObj.channel_name,
                      newObj.get_channel_people_details // Fixed: use new data
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(oldObj.channel_status)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(newObj.channel_status)}
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Access</td>
              <td className={viewLogStyle.tableCell}>
                {getAccessText(oldObj.allow_access)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getAccessText(newObj.allow_access)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const renderUpdateStaffRegisteration = (oldData, newData) => {
    // const changes = getChangesFromObjects(oldData, newData);
    const oldDatas = Array.isArray(oldData) ? oldData[0] : oldData;
    const newDatas = Array.isArray(newData) ? newData[0] : newData;

    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr className={viewLogStyle.tableHeader}>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Old Data</th>
              <th className={viewLogStyle.tableHeader}>Updated Data</th>
            </tr>
          </thead>
          <tbody>
            {/* {Object.entries(data).map(([key, value]) => ( */}
            <tr>
              <td className={viewLogStyle.tableCell}> Name</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.name}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Email</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.email}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.email}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Phone</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.phone}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.phone}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Address</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.address}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.address}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Company</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewCompany(oldDatas.name, oldDatas.company_data_list)
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewCompany(oldDatas.name, newDatas.company_data_list)
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>About</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.about}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.about}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(oldDatas.active_status)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(newDatas.active_status)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  // "add" action
  const renderAddDetails = (category, details) => {
    if (category === "Group") {
      return renderAddGroup(details);
    } else if (category === "Channel") {
      return renderAddChannel(details);
    } else {
      return renderAddStaffRegister(details);
    }
  };

  const renderAddGroup = (details) => {
    const data = Array.isArray(details) ? details[0] : details;
    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Created Data</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={viewLogStyle.tableCell}>Group Name</td>
              <td className={viewLogStyle.tableCell}>{data.group_name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Group Icon</td>
              <td className={viewLogStyle.tableCell}>
                {data.group_icon !== null ? (
                  <img
                    alt="img"
                    className={viewLogStyle.images}
                    src={`${apiUrl}${data.group_icon}`}
                  />
                ) : (
                  <FallbackAvatar name={`${data.group_name} `} size={40} />
                )}
              </td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Admin</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(data.group_name, data.group_admin_details)
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>User</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(data.group_name, data.group_users_details)
                  }
                >
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(data.group_status)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const renderAddChannel = (details) => {
    const data = Array.isArray(details) ? details[0] : details;
    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Created Data</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={viewLogStyle.tableCell}>Channel Name</td>
              <td className={viewLogStyle.tableCell}>{data.channel_name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Channel Topic</td>
              <td className={viewLogStyle.tableCell}>{data.channel_topic}</td>
            </tr>
            <tr>
              <th className={viewLogStyle.tableCell}>Description</th>
              <td className={viewLogStyle.tableCell}>{data.discription}</td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Channel Managers</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(
                      data.channel_name,
                      data.channel_manager_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>User</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(
                      data.channel_name,
                      data.get_channel_people_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(data.channel_status)}
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Access</td>
              <td className={viewLogStyle.tableCell}>{data.allow_access}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const renderAddStaffRegister = (details) => {
    const data = Array.isArray(details) ? details[0] : details;

    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Created Data</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={viewLogStyle.tableCell}> Name</td>
              <td className={viewLogStyle.tableCell}>{data.name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Email</td>
              <td className={viewLogStyle.tableCell}>{data.email}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Phone</td>
              <td className={viewLogStyle.tableCell}>{data.phone}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Address</td>
              <td className={viewLogStyle.tableCell}>{data.address}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Company</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewCompany(data.name, data.company_data_list)
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>About</td>
              <td className={viewLogStyle.tableCell}>{data.about}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(data.active_status)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  // New renderer for "deactive" action
  const renderDeactivationDetails = (category, oldData, newData) => {
    if (category === "Group") {
      return renderActionGroup(oldData, newData);
    } else if (category === "Channel") {
      return renderActionChannel(oldData, newData);
    } else {
      return renderActionStaffReg(oldData, newData);
    }
  };

  const renderActionGroup = (oldData, newData) => {
    const oldDatas = Array.isArray(oldData) ? oldData[0] : oldData;
    const newDatas = Array.isArray(newData) ? newData[0] : newData;
    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Old Data</th>
              <th className={viewLogStyle.tableHeader}>Updated Data</th>{" "}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={viewLogStyle.tableCell}>Group Name</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.group_name}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.group_name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Group Icon</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.group_icon}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.group_icon}</td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Admin</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(
                      oldDatas.group_name,
                      oldDatas.group_admin_details
                    )
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(
                      newDatas.group_name,
                      newDatas.group_admin_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>User</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(
                      oldDatas.group_name,
                      oldDatas.group_users_details
                    )
                  }
                >
                  View
                </button>
              </td>
              <td td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton}
                  onClick={() =>
                    handleViewUser(
                      newDatas.group_name,
                      newDatas.group_users_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(oldDatas.group_status)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(newDatas.group_status)}
              </td>
            </tr>
            {/* <tr>
              <td></td>
              <td></td>
            </tr> */}
          </tbody>
        </table>
      </div>
    );
  };

  const renderActionChannel = (oldData, newData) => {
    const oldDatas = Array.isArray(oldData) ? oldData[0] : oldData;
    const newDatas = Array.isArray(newData) ? newData[0] : newData;
    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Old Data</th>
              <th className={viewLogStyle.tableHeader}>Updated Data</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={viewLogStyle.tableCell}>Channel Name</td>
              <td className={viewLogStyle.tableCell}>
                {oldDatas.channel_name}
              </td>
              <td className={viewLogStyle.tableCell}>
                {newDatas.channel_name}
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Channel Topic</td>
              <td className={viewLogStyle.tableCell}>
                {oldDatas.channel_topic}
              </td>
              <td className={viewLogStyle.tableCell}>
                {newDatas.channel_topic}
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Description</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.discription}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.discription}</td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Channel Managers</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      oldDatas.channel_name,
                      newDatas.channel_manager_details
                    )
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      oldDatas.channel_name,
                      newDatas.channel_manager_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>User</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      oldDatas.channel_name,
                      newDatas.get_channel_people_details
                    )
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewUser(
                      oldDatas.channel_name,
                      newDatas.get_channel_people_details
                    )
                  }
                >
                  View
                </button>
              </td>
            </tr>

            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(oldDatas.channel_status)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(newDatas.channel_status)}
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Access</td>
              <td className={viewLogStyle.tableCell}>
                {" "}
                {getAccessText(oldDatas.allow_access)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getAccessText(newDatas.allow_access)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const renderActionStaffReg = (oldData, newData) => {
    const oldDatas = Array.isArray(oldData) ? oldData[0] : oldData;
    const newDatas = Array.isArray(newData) ? newData[0] : newData;

    return (
      <div className={viewLogStyle.tableContainer}>
        <table className={viewLogStyle.detailsTable}>
          <thead>
            <tr>
              <th className={viewLogStyle.tableHeader}>Field</th>
              <th className={viewLogStyle.tableHeader}>Old Data</th>
              <th className={viewLogStyle.tableHeader}>Updated Data</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={viewLogStyle.tableCell}> Name</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.name}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.name}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Email</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.email}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.email}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Phone</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.phone}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.phone}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Address</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.address}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.address}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Company</td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewCompany(oldDatas.name, oldDatas.company_data_list)
                  }
                >
                  View
                </button>
              </td>
              <td className={viewLogStyle.tableCell}>
                <button
                  className={viewLogStyle.viewButton} // Added button styling
                  onClick={() =>
                    handleViewCompany(oldDatas.name, newDatas.company_data_list)
                  }
                >
                  View
                </button>
              </td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>About</td>
              <td className={viewLogStyle.tableCell}>{oldDatas.about}</td>
              <td className={viewLogStyle.tableCell}>{newDatas.about}</td>
            </tr>
            <tr>
              <td className={viewLogStyle.tableCell}>Status</td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(oldDatas.active_status)}
              </td>
              <td className={viewLogStyle.tableCell}>
                {getStatusText(newDatas.active_status)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className={popupsyle.popupBackground}>
      <div className={editpopup.editPopupContainer}>
        <div className={popupsyle.PopupContainer}>
          <div className={popupsyle.popupHeader}>
            <h3>Log Details</h3>
            <TfiClose
              size={20}
              className={popupsyle.closePopup}
              onClick={onClose}
            />
          </div>

          <div className={viewLogStyle.selectedLogMainCon}>
            {isLoading && <PageLoader />}
            {error && (
              <div className={editpopup.error}>Error: {error.message}</div>
            )}
            {selectedLog && renderLogDetails()}
          </div>
        </div>
      </div>
      {viewCompany && (
        <CompanyView
          onClose={() => setViewCompany(false)}
          show={viewCompany}
          data={datas}
        />
      )}
      {viewUser && (
        <PeopleView
          show={viewUser}
          onClose={() => setViewUser(false)}
          data={userDatas}
        />
      )}
    </div>
  );
};

export default ViewSelectedLog;
